/**
 * Iniciales para badges/avatars, compartido por todas las tablas y headers.
 * Fallback consistente: '#' cuando el nombre está vacío (convención de la
 * mayoría de los consumidores; ClienteDetailHeader usaba '?' antes de la
 * unificación).
 */
export function getInitials(nombre: string | null | undefined): string {
  const words = nombre?.trim().split(/\s+/).filter(Boolean) ?? [];
  if (words.length === 0) return '#';
  return words
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join('');
}
